import { Link } from "react-router-dom";
import type { RegistrationRoleCardProps } from "../core/types/tsx/components/RegistrationRoleCard.types";


export function RegistrationRoleCard({ title, description, icon, to, onClick, disabled = false }: RegistrationRoleCardProps) {
  const className =
    "group flex h-full w-full flex-col items-start gap-4 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-all" +
    (disabled ? " opacity-60" : " cursor-pointer hover:-translate-y-1 hover:border-primary hover:shadow-md");

  const content = (
    <>
      <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-full bg-[#009FB5] text-white shadow-sm ring-4 ring-[#009FB5]/10 transition-all duration-300 group-hover:scale-110 group-hover:ring-[#009FB5]/20">
        <div className="[&>svg]:h-8 [&>svg]:w-8">{icon}</div>
      </div>
      <div className="space-y-2">
        <p className="text-xl font-normal text-slate-800">{title}</p>
        <p className="text-base font-light leading-relaxed text-slate-500">{description}</p>
      </div>
    </>
  );

  if (to && !disabled) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }

  if (onClick && !disabled) {
    return (
      <button type="button" onClick={onClick} className={className + " text-left"}>
        {content}
      </button>
    );
  }

  return (
    <div className={className}>
      {content}
    </div>
  );
}
export type { RegistrationRoleCardProps } from "../core/types/tsx/components/RegistrationRoleCard.types";
